const API_URL = 'https://fiveg-delay-backend.onrender.com';

export async function wakeUpServer() {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 60000);
    const res = await fetch(`${API_URL}/health`, { signal: controller.signal });
    clearTimeout(timeout);
    const data = await res.json();
    return data.status === 'running';
  } catch {
    return false;
  }
}

export async function predictDelays(file) {
  const formData = new FormData();
  formData.append('file', file);

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 180000); // 3 min — enough for cold start + prediction

  try {
    const res = await fetch(`${API_URL}/predict`, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
    });
    clearTimeout(timeout);

    // Try to parse JSON regardless of status code
    let data;
    const text = await res.text();
    try {
      data = JSON.parse(text);
    } catch {
      // Raw non-JSON response from server crash
      throw new Error(`Server returned unexpected response (status ${res.status}). Check Render logs. Raw: ${text.slice(0, 200)}`);
    }

    if (!res.ok) {
      throw new Error(data.error || `Server error (${res.status})`);
    }

    return data;
  } catch (err) {
    clearTimeout(timeout);
    if (err.name === 'AbortError') {
      throw new Error('Request timed out after 3 minutes. The backend may be overloaded — try a smaller CSV (60 rows) first.');
    }
    throw err;
  }
}

export async function getModelInfo() {
  const res = await fetch(`${API_URL}/model-info`);
  return res.json();
}
